module.exports = __webpack_public_path__ + "static/media/let4.1a5d2ca8.JPG";